<template>
  <div>
    <div v-if="list.length || sponsor.length">
      <van-swipe class="swiper-banner" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in list" :key="index" class="swiper-item">
          <iain-image-domain h="200" r="0" :src="item.logo" />
          <div class="swiper-title">{{ item.name }}</div>
        </van-swipe-item>
      </van-swipe>

      <van-swipe class="swiper-sponsor" vertical :autoplay="3000" :show-indicators="false" :touchable="false">
        <van-swipe-item v-for="(item, index) in sponsor" :key="index" class="swiper-item">
          <span>{{ item.name }}赞助</span>
          <span class="swiper-amount">{{ $lodash.formatThousandMark(item.amount / 100) }}</span>
          <span>元</span>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div v-else>
      <iain-gap height="20" />
      <van-empty class="custom mini" description="暂无企业赞助" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    sponsor: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-banner {
  height: 200px;

  .swiper-item {
    position: relative;

    .swiper-title {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      padding: 0 30px;
      width: 100%;
      height: 46px;
      font-size: 24px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.2);
    }
  }
}

.swiper-sponsor {
  padding: 0 30px;
  height: 85px;
  line-height: 85px;

  .swiper-item {
    .swiper-amount {
      color: #ff5500;
      margin: 0 10px;
    }
  }
}
</style>
